import { TabError } from '@/utils/class/TabError'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getSpecificBasicData, getObjectByCache } from '@/utils/basicDataCache'
import StrUtils from '@/utils/StrUtils'
import * as CargoDocCfmState from '@/class/cargo/model/parameters/CargoDocCfmState'
import * as ReleaseState from '@/class/cargo/model/parameters/ReleaseState'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import * as BillReleaseType from '@/class/cargo/model/parameters/BillReleaseType'
import * as BookingTerm from '@/class/cargo/model/parameters/BookingTerm'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { DocCommon } from '@/class/cargo/model/utils/DocCommon'
import { SeaExportUtils } from '@/class/cargo/model/utils/SeaExportUtils'
import { Company } from '@/class/model/mdm/Company'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { SeaImCargoDoc } from '@/class/model/booking/SeaImCargoDoc'
import { AfrAddress } from '@/class/model/booking/AfrAddress'
import { Vessel } from '@/class/model/mdm/Vessel'
import { Voyage } from '@/class/model/mdm/Voyage'
import { PrintUtils } from '@/utils/PrintUtils'
import { postRemotingTracking } from '@/api/seaExport/seaCargoDoc'
import { updateTrackingEvent } from '@/api/trackingService'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import AbstractViewManage from '@/class/view/AbstractViewManage'
import { BillAddressCommonPM } from '@/class/common/BillAddressCommonPM'
import * as FileType from '@/class/cargo/model/parameters/FileType'
import { File } from '@/class/model/booking/File'
import * as BlModeType from '@/class/cargo/model/parameters/BlModeType'
import { surrendered } from '@/api/SeaImport/seaImCargoDoc'
import { DOC_PAGE_SOURCE } from '@/class/cargo/model/parameters/SystemConstants'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'

export class TabHBLPM extends AbstractViewManage {
  /**
   * @param {Object} view 视图
   */
  constructor(view) {
    super(view)
    this.view = view
    this.prompt1TitleWindow = null
    this.promptTitleWindow = null
    this._voyages = []
    this._allowEditingVessel = false
    this.editVesselVoyageMode = 2 // 船名编辑模式
    this.editVoyageMode = 2 // 航次
    this._lclslaveEnabled = false
    this.afrAddressWindow = null // 反恐地址维护
    this.isEditSingleCargoDoc = false // 是否允许修改被并单的数据
    this.originalPrintCheckSerialNo = false // 提单流水号打印验证
    this.isCanEditQwc = false // 是否可编辑件毛体
    this.checkHistoryLabMap = {}
    this.checkHistoryTextMap = {}
    this.alertFlag = true
    // this.synchronousShipperCodeAndConsigneeCodeAndNotifyCode = false // 是否同步收发通代码到基本页签
    this.jionFlag = false // 是否有并单
    this.currentVessel = null // 当前船名航次
    this.printParam4Type = [
      { label: '', data: '' },
      { label: 'AS CARRIER', data: 'AS CARRIER' },
      { label: 'AS AGENT FOR THE CARRIER', data: 'AS AGENT FOR THE CARRIER' },
      { label: 'AS AGENT FOR ', data: 'AS AGENT FOR ' }
    ]
    this.printParam5Type = [
      { label: '', data: '' },
      { label: 'SEABRIDGE FCL', data: 'DELIVERY ORDER FEE ON ACCOUNT OF CNEE' },
      {
        label: 'SEABRIDGE LCL NORMAL',
        data: 'DESTINATION CFS CHARGES INCL.DELIVERY ORDER FEE AND GSC CHARGES ON ACCOUNT OF CNEE'
      },
      {
        label: 'SEABRIDGE LCL INCLUDE CISF',
        data: 'DESTINATION CFS CHARGES INCL.DELIVERY ORDER FEE AND GSC CHARGES AND CISF ON ACCOUNT OF CNEE'
      }
    ]
    this.view.$nextTick(() => {
      this.creationCompleteHandler()
    })
    // _view.dgFreightCharges.addEventListener(KeyboardEvent.KEY_DOWN, freightChargesHandler)
  }

  get synchronousShipperCodeAndConsigneeCodeAndNotifyCode() {
    return this.view.synchronousShipperCodeAndConsigneeCodeAndNotifyCode
  }

  set synchronousShipperCodeAndConsigneeCodeAndNotifyCode(value) {
    this.view.synchronousShipperCodeAndConsigneeCodeAndNotifyCode = value
  }

  get context() {
    return this.view.context
  }

  set context(context) {
    this.view.context = context
  }

  get companyList() {
    return this.view.context.companyList
  }

  set companyList(companyList) {
    this.view.context.companyList = companyList
  }

  get user() {
    return this.context.user
  }

  set user(user) {
    // 不可赋值
  }

  get config() {
    return this.view.config
  }

  set config(config) {
    // 不可赋值
  }

  get job() {
    return this.view.job
  }

  set job(job) {
    this.view.job = job
  }

  get form() {
    return this.view.form
  }

  set form(form) {
    this.view.addrPM = new BillAddressCommonPM(this.view)
    this.view.addrPM.job = this.job
    this.view.form = form
  }

  /**
   * init
   */
  async init() {
    this.view.maxChars = 45
    this.view.warningCount = Number(this.config.get('SEShipperConsigneNotifyWarningColor')) || 35
    // 从配置中读取英文品名最大字符数
    const maxChars = Number(this.config.get('SEEnglishDescriptionOfGoodsMaxchars'))
    if (maxChars > 0) {
      this.view.englishNameMaxChars = maxChars
    }
    // 从配置中读取唛头最大字符数
    const maxChars2 = Number(this.config.get('SEMarkMaxChars'))
    if (maxChars2 > 0) {
      this.view.markMaxChars = maxChars2
    }
    // 从配置中读取海运出口MBL英文品名标红字符数
    const maxColor = Number(this.config.get('SEEnglishDescriptionOfGoodWarningColor'))
    if (maxColor > 0) {
      this.view.englishNameWarningCount = maxColor
    }
    // 从配置中读取海运出口MBL唛头标红字符数
    const maxColor2 = Number(this.config.get('SEMarkWarningColor'))
    if (maxColor2 > 0) {
      this.view.markWarningCount = maxColor2
    }
    this.originalPrintCheckSerialNo = Number(this.config.get('originalPrintCheckSerialNo')) === 1
    this.editVesselVoyageMode = Number(this.config.get('EditVesselVoyageMode'))
    this.editVoyageMode = Number(this.config.get('EditVoyageMode'))
    this.isEditSingleCargoDoc = Number(this.config.get('SingleCargoDocEdit')) === 1
    this.synchronousShipperCodeAndConsigneeCodeAndNotifyCode = Number(this.config.get('synchronousShipperCodeAndConsigneeCodeAndNotifyCode')) === 1
    await Promise.all([
      getSpecificBasicData(basicCacheKeys.basic_data_ShippingTerm).then(data => {
        this.shippingTermList = data
      }),
      getSpecificBasicData(basicCacheKeys.basic_data_PaymentTerm).then(data => {
        this.paymentTermList = data
      }),
      getSpecificBasicData(basicCacheKeys.basic_data_OrderFormType).then(data => {
        this.orderFormTypeList = data
      }),
      getSpecificBasicData(basicCacheKeys.basic_data_BlMode).then(data => {
        const serialNumbers = this.view.blModeList.map(bm => bm.serialNumber)
        for (const item of data) {
          if (item.blType === BlModeType.HBL.code && !serialNumbers.includes(item.serialNumber)) {
            this.view.blModeList.push(item)
          }
        }
      }),
      getSpecificBasicData(basicCacheKeys.basic_data_Packing).then(data => {
        this.packingList = data
      }),
      getSpecificBasicData(basicCacheKeys.basic_data_Vessel).then(data => {
        this.vesselList = data
      })
    ])
  }

  creationCompleteHandler(evt) {
    this.editInputVesselModel()
    this.lclslaveEnabledChanged()
  }

  display() {
    this.checkCmbtypeHBLEnabled()
  }

  async changeJob() {
    const job = new SeaImportJob(this.job)
    const cargoDoc = await job.getSeaCargoDoc()
    await this.loadCargoDoc2Handler(cargoDoc)
    const jointSlavesHBL = await job.getJointSlavesHBL()
    this.loadJointSlaves2Handler(jointSlavesHBL)
    await job.getJointMasterHBL()
    if (this.alertFlag && this.jionFlag) {
      this.alertFlag = false
      if (this.job.jointMasterHBL) {
        this.$message.info(this.view.$t('Message.ThisHblIsCombinedAndCannotBeEdited1') + '（' + this.job.jointMasterHBL.jobNo + '),' + this.view.$t('Message.hisHblIsCombinedAndCannotBeEdited2'))
      }
    }
  }

  async fillView() {
    this.editInputVesselModel()
    this.lclslaveEnabledChanged()
    this.resetColor()
    this.showCarrierAgentScac()
    this.refushLoadType()
    if (!this.form.freightTermHBL) {
      const shippingTerm = this.shippingTermList.find(p => p.code === this.job.freightTermHBL)
      if (shippingTerm) {
        this.form.freightTermHBL = shippingTerm.name
      }
    }
    if (!this.form.uuid) { // 新增的时候要重新计算件数大写，编辑情况下要显示数据库真实数据
      this.refreshQuantitySum()
    }
  }

  refushLoadType() {
    if (this.view.isEdit) {
      if (this.job.containerUsages) {
        this.form.container = SeaExportUtils.getContainerDesc(this.job, false)
      }
    }
  }

  async fillModel() {
    if (!this.form.uuid) {
      this.form.cfmState = CargoDocCfmState.CARGODOC_CFM_STATE_DHD.code
    }
    // 提单发货地
    this.form.dispatchingPlace = this.form.dispatchingPlace.toUpperCase()
    // 提单起运港
    this.form.loadingPort = this.form.loadingPort.toUpperCase()
    // 提单卸货港
    this.form.dischargingPort = this.form.dischargingPort.toUpperCase()
    // 提单目的港
    this.form.destinationPort = this.form.destinationPort.toUpperCase()
    // 提单目的地
    this.form.destinationPlace = this.form.destinationPlace.toUpperCase()

    this.form.containerSum = ContainerUtil.getSeaeqNumberStr(this.job)

    // 提单份数
    this.form.blNumber = this.form.blNumber.toUpperCase()

    const billOfLadingSynMode = parseInt(this.config.get('BillOfLadingSynMode'))
    // 包装
    if (this.view.isEdit && billOfLadingSynMode === 2) {
      this.job.packing = this.form.packing
    }
    // 唛头
    // 提单备注
    this.form.remarks = this.form.remarks.toUpperCase()
    // this.form.cargoEnglishName = this.form.cargoEnglishName.toUpperCase()
    // this.form.mark = this.form.mark.toUpperCase()
    this.form.state = this.form.state || 1
    this.form.container = this.form.container.toUpperCase()
    this.form.alsoNotify = this.form.alsoNotify.toUpperCase()
    await this.changeAfrAddress()
  }

  validateForm() {
    if (this.form.releaseType === BillReleaseType.SURRENDERED.code) {
      const regexp = /^\W*to\W*-?\W*order\W*$/i
      if (regexp.test(this.form.consigneeLine1)) {
        throw new TabError(this.view.$t('Message.ToOrederBlCannotBeTelexReleased'), 'tabHBL')
      }
    }
  }

  async executeTask() {
    DocCommon.HBL_History.shipperLine1 = this.form.shipperLine1
    DocCommon.HBL_History.shipperLine2 = this.form.shipperLine2
    DocCommon.HBL_History.shipperLine3 = this.form.shipperLine3
    DocCommon.HBL_History.shipperLine4 = this.form.shipperLine4
    DocCommon.HBL_History.shipperLine5 = this.form.shipperLine5
    DocCommon.HBL_History.shipperLine6 = this.form.shipperLine6
    DocCommon.HBL_History.shipperCode = this.shipperCode
    DocCommon.HBL_History.consigneeLine1 = this.form.consigneeLine1
    DocCommon.HBL_History.consigneeLine2 = this.form.consigneeLine2
    DocCommon.HBL_History.consigneeLine3 = this.form.consigneeLine3
    DocCommon.HBL_History.consigneeLine4 = this.form.consigneeLine4
    DocCommon.HBL_History.consigneeLine5 = this.form.consigneeLine5
    DocCommon.HBL_History.consigneeLine6 = this.form.consigneeLine6
    DocCommon.HBL_History.consigneeCode = this.form.consigneeCode
    DocCommon.HBL_History.notifyLine1 = this.form.notifyLine1
    DocCommon.HBL_History.notifyLine2 = this.form.notifyLine2
    DocCommon.HBL_History.notifyLine3 = this.form.notifyLine3
    DocCommon.HBL_History.notifyLine4 = this.form.notifyLine4
    DocCommon.HBL_History.notifyLine5 = this.form.notifyLine5
    DocCommon.HBL_History.notifyLine6 = this.form.notifyLine6
    DocCommon.HBL_History.notifyCode = this.form.notifyCode
    DocCommon.HBL_History.englishCargoName = this.form.cargoEnglishName
    DocCommon.HBL_History.mark = this.form.mark
    if (parseInt(this.config.get('syncMailingAddress')) === 1) {
      this.view.addrPM.saveCheck()
    }
  }

  autoAuditSingleReleaseHBLHandler(state) {
    if (state && state !== 99) {
      this.form.releaseState = state // 刷新
      const releaseState = ReleaseState.getReleaseStateByCode(this.form.releaseState)
      if (releaseState) {
        this.view.lblReleaseState = this.view.$i18n.locale === 'zh' ? releaseState.chineseName : releaseState.englishName
      }
    }
  }

  /**
   * 打印hbl
   */
  printHblPost(event) {
    if (event.action === 'print') {
      updateTrackingEvent({ jobUuid: this.job.uuid, eventCode: 'print_hbl' }).then(async res => {
        this.job.trackingInfo = ''
        await new SeaImportJob(this.job).getTrackingInfo()
      }).finally(() => {
      })
    }
  }

  /**
   * V2打印反馈
   */
  v2CheckCallbackFun(printed, template, entity, params) {
    if (printed) {
      this.updateTrackingEvent()
    }
  }

  async updateTrackingEvent(result = null) {
    this.job.trackingInfo = ''
    await new SeaImportJob(this.job).getTrackingInfo()
  }

  print_callback(event) {
    if (event.action === 'print') {
      this.form.state = 2
      surrendered({
        cargoDocUuid: this.form.uuid,
        cfmState: this.form.cfmState,
        state: this.form.state
      }).then(async res => {
        if (res.data) {
          Object.assign(this.form, res.data)
          this.loadJointSlaves2Handler()
        }
      }).finally(() => {
      })
      this.startCreateFile()
      this.lockBookingTab()
      this.postRemotingTracking('SE-IssueHBL')
    }
  }

  async v2CheckCallbackFun2(printed, template, entity, params) {
    // 提单状态改为已放单
    if (printed && params.event && params.event.action === PrintUtils.PRINT) {
      this.form.cfmState = 10
      // this.form.state = 2
      surrendered({
        cargoDocUuid: this.form.uuid,
        cfmState: this.form.cfmState,
        state: this.form.state
      }).then(async res => {
        if (res.data) {
          Object.assign(this.form, res.data)
        }
        this.loadJointSlaves2Handler()
        this.postRemotingTracking('SE-IssueHBL')
      }).finally(() => {
      })
    } else {
      this.job.cargoDoc = ''
      const jobClass = new SeaImportJob(this.job)
      await jobClass.getCargoDoc()
      this.loadJointSlaves2Handler()
      this.postRemotingTracking('SE-IssueHBL')
    }
  }

  postRemotingTracking(eventCode) {
    postRemotingTracking({ jobUuid: this.job.uuid, eventCode: eventCode }).then(res => {
    }).finally(() => {
    })
  }

  async loadCargoDoc2Handler(cargoDocList) {
    this.form = null
    if (cargoDocList.length > 0) {
      for (const hCargoDoc of cargoDocList) {
        if (hCargoDoc.docType === CargoDocConsts.HBL) {
          this.form = hCargoDoc
        }
        if (hCargoDoc.docType === CargoDocConsts.HBL2 && this.job.typeHBL === BillType.SPLIT_BILL_TYPE.code) {
          this.view.cmbtypeHBLDisabled = true
        }
      }
    }
    if (!this.form) {
      this.form = new SeaImCargoDoc().fillDefaultValue().getData()
      this.form.afrAddress = []
      await SeaImCargoDoc.copyInfoFromSeaImportJob(this.job, this.form)
      this.form.docType = CargoDocConsts.HBL
      this.form.jobUuid = this.job.uuid
      cargoDocList.push(this.form)
    } else {
      this.view.chkConsolidationClosed = false
      const afrAddress = await new SeaImCargoDoc(this.form).getAfrAddress()
      if (afrAddress && afrAddress.length > 0) {
        this.loadAfrAddressHandler(afrAddress[0])
        this.form.chkConsolidationClosed = afrAddress[0].consolidationClosed > 0
      } else {
        this.form.chkConsolidationClosed = false
      }
      if (this.form.pageSource === DOC_PAGE_SOURCE) {
        // 暂时不用 copyInfoFromSeaExportJob
        await SeaCargoDoc.copyInfoFromJobPort(this.job, this.form)
        this.form.signPlaceBL = this.job.signPlaceBL
      }
    }
    /* if (!this.form.hblNbr2) {
      this.form.hblNbr2 = this.job.jobNo
    }*/
    this.cmbissuerHBL_changeHandler()
    this.editingChanged()
    await this.checkReleaseTypeState()
    this.docCfmStateChanged()
    this.controlQwcRoleEdit()
  }

  hblFunction(txtHBLNo) {
    if (this.job && this.form.hblNbr2) {
      this.job.hbl = this.form.hblNbr2
    }
  }

  /**
   * 加载并单
   */
  async loadJointSlaves2Handler(result = null) {
    await this.checkCmbtypeHBLEnabled()
    this.printStateChange()
    this.checkUnlockBtnState()
  }

  /**
   * check doc tyoe enable
   */
  async checkCmbtypeHBLEnabled() {
    const job = new SeaImportJob(this.job)
    const jointSlavesHBL = await job.getJointSlavesHBL()
    console.log('===', jointSlavesHBL)
    if (jointSlavesHBL && jointSlavesHBL.length > 0) {
      this.view.cmbtypeHBLDisabled = true
    } else {
      this.view.cmbtypeHBLDisabled = this.view.readonly
    }
  }

  /**
   * afr
   */
  loadAfrAddressHandler(afrAddress) {
    this.view.chkConsolidationClosed = afrAddress && afrAddress.consolidationClosed > 0
  }

  /**
   * 运费
   */
  loadFreightChargesHandler(freightCharges) {
    this.view.rowData = freightCharges
  }

  queryTopCheckDocHistoriesHandler(checkDocHistories) {
    this.comparedCargoDocIsModified(checkDocHistories)
  }

  /**
   * 对单后把有修改的内容显示红色
   */
  comparedCargoDocIsModified(checkDocHistories) {
    if (checkDocHistories && checkDocHistories.length > 0) {
      const variableCss = this.view.variableCss
      // 获取对单记录的第一条记录，根据是否有标识字段判断是否对单时修改了字段,有字段修改的情况去改变字段颜色
      const firstCheckDaoHistory = checkDocHistories[0]
      if (firstCheckDaoHistory.fieldName !== 'noChange') {
        for (const checkDocHistory of checkDocHistories) {
          const fieldName = checkDocHistory.fieldName
          if (variableCss.hasOwnProperty(fieldName)) {
            if (fieldName === 'cargoEnglishName' && this.form.cargoEnglishName.length >= 45) {
              continue
            } else if (fieldName === 'mark' && this.form.mark.length >= 22) {
              continue
            }
            this.checkHistoryTextMapChanged(checkDocHistory, checkDocHistories)
          }
        }
      }
    }
  }

  /**
   * 对单内容
   */
  checkHistoryTextMapChanged(checkDocHistory, checkDocHistories) {
    switch (checkDocHistory.fieldName) {
      case 'shipperLine':
        this.checkHistoryByShipperConsigneeNotifyLine('shipperLineOld', 'shipperLine', checkDocHistory, checkDocHistories)
        break
      case 'consigneeLine':
        this.checkHistoryByShipperConsigneeNotifyLine('consigneeLineOld', 'consigneeLine', checkDocHistory, checkDocHistories)
        break
      case 'notifyLine':
        this.checkHistoryByShipperConsigneeNotifyLine('notifyLineOld', 'notifyLine', checkDocHistory, checkDocHistories)
        break
      case 'agentPartyLine':
        this.checkHistoryByShipperConsigneeNotifyLine('agentPartyLineOld', 'agentPartyLine', checkDocHistory, checkDocHistories)
        break
      default:
        this.view.variableCss[checkDocHistory.fieldName] = 'red'
        break
    }
  }

  /**
   * 检查收发通知人是否发生变化
   */
  checkHistoryByShipperConsigneeNotifyLine(oldField, textField, checkDocHistory, checkDocHistories) {
    const line = checkDocHistory.fieldValue
    const oldLine = this.getDocHistoryShipperConsigneeNotify(oldField, checkDocHistories)
    const lines = line.split('|')
    const oldLines = oldLine.split('|')
    for (let i = 0; i < lines.length; ++i) {
      const index = i + 1
      const line2 = lines[i].replace('\r\n', '')
      const lineOld2 = oldLines[i].replace('\r\n', '')
      if (line2 !== lineOld2) {
        this.view.variableCss[textField + index] = 'red'
      }
    }
  }

  /**
   * 获取上一个版本收发通历史的数据
   */
  getDocHistoryShipperConsigneeNotify(fieldName, checkDocHistories) {
    for (const history in checkDocHistories) {
      if (history.fieldName === fieldName) {
        return history.fieldValue
      }
    }
    return ''
  }

  /**
   * 重置对单颜色
   */
  resetColor() {
    for (const key in this.view.variableCss) {
      if (key === 'cargoEnglishName' && this.form.cargoEnglishName.length >= 45) {
        continue
      } else if (key === 'mark' && this.form.mark.length >= 22) {
        continue
      }
      this.view.variableCss[key] = ''
    }
  }

  /**
   * 提单种类修改
   */
  cmbissuerHBL_changeHandler(data) {
    if (!data) {
      if (this.orderFormTypeList && this.orderFormTypeList.length > 0) {
        data = this.orderFormTypeList.find(p => p.code === this.form.issuerBL)
        if (!data) {
          data = this.orderFormTypeList[0]
          this.form.issuerBL = data.code
        }
      }
    } else {
      this.form.issuerBL = data.code
      if (data.code === 'TH') {
        this.view.hblNoDisabled = false
      } else {
        this.view.hblNoDisabled = this.config.get('SEAllowEditHBLNo') !== '1'
      }
    }
    this.printStateChange()
  }

  validate6Line(s) {
    return true
  }

  /**
   * reset 收发通地址
   */
  onClear(type) {
    switch (type) {
      case 1:
        this.form.shipperCode = ''
        this.form.shipperLine1 = ''
        this.form.shipperLine2 = ''
        this.form.shipperLine3 = ''
        this.form.shipperLine4 = ''
        this.form.shipperLine5 = ''
        this.form.shipperLine6 = ''
        this.form.shipperLine7 = null
        break
      case 2:
        this.form.consigneeCode = ''
        this.form.consigneeLine1 = ''
        this.form.consigneeLine2 = ''
        this.form.consigneeLine3 = ''
        this.form.consigneeLine4 = ''
        this.form.consigneeLine5 = ''
        this.form.consigneeLine6 = ''
        this.form.consigneeLine7 = null
        break
      case 3:
        this.form.notifyCode = ''
        this.form.notifyLine1 = ''
        this.form.notifyLine2 = ''
        this.form.notifyLine3 = ''
        this.form.notifyLine4 = ''
        this.form.notifyLine5 = ''
        this.form.notifyLine6 = ''
        this.form.notifyLine7 = null
        break
      case 4:
        this.form.agentPartyLine1 = ''
        this.form.agentPartyLine2 = ''
        this.form.agentPartyLine3 = ''
        this.form.agentPartyLine4 = ''
        this.form.agentPartyLine5 = ''
        this.form.agentPartyLine6 = ''
        this.form.agentPartyLine7 = ''
        break
      default:
        break
    }
  }

  /**
   * 发货人选择
   */
  async shipperAutoCompleteChange(data) {
    this.form.shipperId = data.value
    await JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, this.synchronousShipperCodeAndConsigneeCodeAndNotifyCode, 'shipper', 1)
    const company = new Company(data)
    await company.getMainfestAddress()
    this.applyShipperManifestAddress(data)
  }

  applyShipperManifestAddress(company) {
    const manifestaddress = company.manifestAddress
    if (manifestaddress) {
      this.form.shipperCode = company.englishName
      this.form.shipperLine1 = manifestaddress.addressLine1
      this.form.shipperLine2 = manifestaddress.addressLine2
      this.form.shipperLine3 = manifestaddress.addressLine3
      this.form.shipperLine4 = manifestaddress.addressLine4
      this.form.shipperLine5 = manifestaddress.addressLine5
      this.form.shipperLine6 = manifestaddress.addressLine6
      this.form.shipperLine7 = manifestaddress.addressLine7
    } else {
      this.form.shipperCode = ''
      this.form.shipperLine1 = ''
      this.form.shipperLine2 = ''
      this.form.shipperLine3 = ''
      this.form.shipperLine4 = ''
      this.form.shipperLine5 = ''
      this.form.shipperLine6 = ''
      this.form.shipperLine7 = ''
    }
  }

  /**
   * 收货人选择
   */
  async consigneeAutoCompleteChange(data) {
    this.form.consigneeId = data.value
    await JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, this.synchronousShipperCodeAndConsigneeCodeAndNotifyCode, 'consignee', 1)
    const company = new Company(data)
    await company.getMainfestAddress()
    this.applyConsigneeManifestAddress(data)
  }

  applyConsigneeManifestAddress(company) {
    const manifestaddress = company.manifestAddress
    if (manifestaddress) {
      this.form.consigneeCode = company.englishName
      this.form.consigneeLine1 = manifestaddress.addressLine1
      this.form.consigneeLine2 = manifestaddress.addressLine2
      this.form.consigneeLine3 = manifestaddress.addressLine3
      this.form.consigneeLine4 = manifestaddress.addressLine4
      this.form.consigneeLine5 = manifestaddress.addressLine5
      this.form.consigneeLine6 = manifestaddress.addressLine6
      this.form.consigneeLine7 = manifestaddress.addressLine7
    } else {
      this.form.consigneeCode = ''
      this.form.consigneeLine1 = ''
      this.form.consigneeLine2 = ''
      this.form.consigneeLine3 = ''
      this.form.consigneeLine4 = ''
      this.form.consigneeLine5 = ''
      this.form.consigneeLine6 = ''
      this.form.consigneeLine7 = ''
    }
  }

  /**
   * 通知人选择
   */
  async notifyAutoCompleteChange(data) {
    this.form.notifyId = data.value
    await JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, this.synchronousShipperCodeAndConsigneeCodeAndNotifyCode, 'notify', 1)
    const company = new Company(data)
    await company.getMainfestAddress()
    this.applyNotifyManifestAddress(data)
  }

  applyNotifyManifestAddress(company) {
    const manifestaddress = company.manifestAddress
    if (manifestaddress) {
      this.form.notifyCode = company.englishName
      this.form.notifyLine1 = manifestaddress.addressLine1
      this.form.notifyLine2 = manifestaddress.addressLine2
      this.form.notifyLine3 = manifestaddress.addressLine3
      this.form.notifyLine4 = manifestaddress.addressLine4
      this.form.notifyLine5 = manifestaddress.addressLine5
      this.form.notifyLine6 = manifestaddress.addressLine6
      this.form.notifyLine7 = manifestaddress.addressLine7
    } else {
      this.form.notifyCode = ''
      this.form.notifyLine1 = ''
      this.form.notifyLine2 = ''
      this.form.notifyLine3 = ''
      this.form.notifyLine4 = ''
      this.form.notifyLine5 = ''
      this.form.notifyLine6 = ''
      this.form.notifyLine7 = ''
    }
  }

  /**
   * 抄录上次
   */
  onCopy1() {
    this.form.cargoEnglishName = DocCommon.HBL_History.englishCargoName
    this.form.mark = DocCommon.HBL_History.mark
  }

  selectionItemHandler(rows) {
    const selectedHBL = rows[0]
    if (selectedHBL) {
      this.form.shipperCode = selectedHBL.shipperCode
      this.form.shipperLine1 = selectedHBL.shipperLine1
      this.form.shipperLine2 = selectedHBL.shipperLine2
      this.form.shipperLine3 = selectedHBL.shipperLine3
      this.form.shipperLine4 = selectedHBL.shipperLine4
      this.form.shipperLine5 = selectedHBL.shipperLine5
      this.form.shipperLine6 = selectedHBL.shipperLine6

      this.form.consigneeCode = selectedHBL.consigneeCode
      this.form.consigneeLine1 = selectedHBL.consigneeLine1
      this.form.consigneeLine2 = selectedHBL.consigneeLine2
      this.form.consigneeLine3 = selectedHBL.consigneeLine3
      this.form.consigneeLine4 = selectedHBL.consigneeLine4
      this.form.consigneeLine5 = selectedHBL.consigneeLine5
      this.form.consigneeLine6 = selectedHBL.consigneeLine6

      this.form.notifyCode = selectedHBL.notifyCode
      this.form.notifyLine1 = selectedHBL.notifyLine1
      this.form.notifyLine2 = selectedHBL.notifyLine2
      this.form.notifyLine3 = selectedHBL.notifyLine3
      this.form.notifyLine4 = selectedHBL.notifyLine4
      this.form.notifyLine5 = selectedHBL.notifyLine5
      this.form.notifyLine6 = selectedHBL.notifyLine6

      this.form.cargoEnglishName = this.job.cargoEnglishName
      this.form.mark = this.job.mark
    }
  }

  /**
   * 抄录MBL
   */
  async onCopyMBL() {
    const mdoc = await new SeaImportJob(this.job).getMainMbl(false)
    if (mdoc) {
      this.form.cargoEnglishName = mdoc.cargoEnglishName
      this.form.mark = mdoc.mark
    }
  }

  /**
   * 抄录收货人
   */
  onCopy_consignee() {
    this.form.notifyCode = this.form.consigneeCode
    this.form.notifyLine1 = this.form.consigneeLine1
    this.form.notifyLine2 = this.form.consigneeLine2
    this.form.notifyLine3 = this.form.consigneeLine3
    this.form.notifyLine4 = this.form.consigneeLine4
    this.form.notifyLine5 = this.form.consigneeLine5
    this.form.notifyLine6 = this.form.consigneeLine6
    this.form.notifyLine7 = this.form.consigneeLine7
  }

  /**
   * 复制主单收货人
   */
  async onCopy_agentParty() {
    const mdoc = await new SeaImportJob(this.job).getMainMbl()
    if (mdoc) {
      this.form.agentPartyLine1 = mdoc.consigneeLine1
      this.form.agentPartyLine2 = mdoc.consigneeLine2
      this.form.agentPartyLine3 = mdoc.consigneeLine3
      this.form.agentPartyLine4 = mdoc.consigneeLine4
      this.form.agentPartyLine5 = mdoc.consigneeLine5
      this.form.agentPartyLine6 = mdoc.consigneeLine6
    }
  }

  /**
   * 取指定货代理信息
   */
  onCopy_designationAgent() {
    const cpy = this.context.companyList.find(p => p.cmpIdx === this.job.designationAgent)
    if (cpy) {
      new Company(cpy).getOverseaAgentDetail().then(data => {
        this.loadDestinationAgentHandler(data)
      })
    }
  }

  loadDestinationAgentHandler(overseaAgentDetail) {
    if (overseaAgentDetail) {
      this.form.agentPartyLine1 = overseaAgentDetail.blAddress
      this.form.agentPartyLine2 = overseaAgentDetail.blAddressLine2
      this.form.agentPartyLine3 = overseaAgentDetail.blAddressLine3
      this.form.agentPartyLine4 = overseaAgentDetail.blAddressLine4
      this.form.agentPartyLine5 = overseaAgentDetail.blAddressLine5
      this.form.agentPartyLine6 = overseaAgentDetail.blAddressLine6
    }
  }

  /**
   * 锁定按钮处理
   */
  onSubmitStateEvent(event) {
    this.form.state = 1
    surrendered({
      cargoDocUuid: this.form.uuid,
      cfmState: this.form.cfmState,
      state: this.form.state
    }).then(async res => {
      this.job.cargoDoc = ''
      const jobClass = new SeaImportJob(this.job)
      await jobClass.getCargoDoc()
      this.unLockCargoDocHandler()
    }).finally(() => {
    })
  }

  /**
   * 解锁
   */
  unLockCargoDocHandler(e) {
    this.job.printHblZbLock = false
    this.loadJointSlaves2Handler()
  }

  /**
   * 投保
   */
  async toInsure() {
    const payload = {
      jobUuid: this.job.uuid,
      branchId: this.view.$store.getters.currentOfficeId,
      docUuid: this.form.uuid,
      billno: this.form.hblNbr2,
      insureType: 'DOC'
    }
    const continueExec = await JobUtils.openInsure(payload, this.view)
    if (continueExec) {
      // 跳转的key 再货运险列表中使用的是记录的UUID,此处没有生成使用billno替代
      this.view.$router.push({
        name: 'ToInsurePage',
        query: { openNew: true, title: this.view.$t('Insurance.ToInsure') + payload.billno, key: payload.billno },
        params: { insureForm: payload }
      })
    }
    // if (Number(this.config.get('isPlatformInsurance')) === 3) {
    //   const payload = {
    //     jobUuid: this.job.uuid,
    //     branchId: $store.getters.currentOfficeId,
    //     docUuid: this.form.uuid,
    //     billno: this.form.hblNbr2,
    //     insureType: 'DOC'
    //   }
    //   const continueExec = await JobUtils.openInsure(payload, this.view)
    //   if (continueExec) {
    //     // 跳转的key 再货运险列表中使用的是记录的UUID,此处没有生成使用billno替代
    //     this.view.$router.push({
    //       name: 'ToInsurePage',
    //       query: { openNew: true, title: this.view.$t('Insurance.ToInsure') + payload.billno, key: payload.billno },
    //       params: { insureForm: payload }
    //     })
    //   }
    //   return
    // }
    // if (this.config.get('BurialPointMode') === 'on') {
    //   // LogStores.sendFunctionClickLogStoresByLabel('SI-HBL-投保')
    // }
    // if (this.view.$checkPermission(['button_insurance_toInsure'])) {
    //   let hbl = null
    //   for (const doc of this.job.seaCargoDoc) {
    //     if (doc.docType === CargoDocConsts.HBL) {
    //       hbl = doc
    //       break
    //     }
    //   }
    //   // 因装箱 组装了 containerUsage与container的 循环依赖关系,重新copy job
    //   const jobCopy = { ...this.job }
    //   if (Object.prototype.hasOwnProperty.call(jobCopy, 'containerUsages')) {
    //     for (const usage of jobCopy.containerUsages) {
    //       delete usage.container
    //     }
    //   }
    //   SeaImCargoDoc.toInsure(this.user.tenantName, hbl, jobCopy, this.context.office).then(data => {
    //     this.insureSuccessHandler(data)
    //   })
    // } else {
    //   this.view.$message.warning(this.view.$t('SeaExport.NotInsuranceOperationPermission'))
    // }
  }

  /**
   * 投保成功
   */
  // insureSuccessHandler(data) {
  //   const result = data.result
  //   const status = data.status
  //   if (status === 'true') {
  //     window.open(result, '_blank', 'noreferrer')
  //   } else {
  //     this.$message.warning(result)
  //   }
  // }

  /**
   * 提单种类更改处理
   */
  cmbtypeHBLChangeHandler(val) {
    const job = this.job
    const hbl2Types = [BillType.SPLIT_BILL_TYPE.code, BillType.MERGE_BILL_TYPE.code]
    if (hbl2Types.includes(job.typeHBL) && hbl2Types.includes(val) && job.typeHBL !== val) {
      this.view.$emit('resetTab', 'tabHBL2')
    }

    if (hbl2Types.includes(job.typeHBL) && job.typeHBL !== val) {
      const cargoDocArr = this.job.seaCargoDoc
      for (let i = cargoDocArr.length - 1; i >= 0; --i) {
        const item = cargoDocArr[i]
        if (item.docType === CargoDocConsts.HBL2) {
          item.deleted = true
          this.addCargoDocToModifiedSet(item)
          cargoDocArr.splice(i, 1)
        }
      }
    }
    job.typeHBL = val
  }

  // 添加cargoDoc到被修改的集合中
  addCargoDocToModifiedSet(item) {
    const modifiedData = this.context.modifiedData
    modifiedData.seaCargoDoc = modifiedData.seaCargoDoc || []
    const oldItem = modifiedData.seaCargoDoc.find(p => p === item)
    if (oldItem) {
      Object.assign(oldItem, item)
    } else {
      modifiedData.seaCargoDoc.push(item)
    }
  }

  /**
   * 提单方式更改处理
   */
  cmbreleaseTypeMBL_changeHandler(val) {
    if (Number(val) === 1) {
      this.form.blNumber = 'THREE'
    } else {
      this.form.blNumber = 'ONE'
    }
  }

  /**
   * 船名航次选择
   */
  async onVesselSelectionChange(data) {
    this.job.vessel = data.value.toUpperCase()
    this.currentVessel = null
    if (data.uuid) {
      this.currentVessel = data
    }

    await this.getVoyageByVessel()

    if (this.currentVessel && this.currentVessel.vesselId) {
      new Vessel(this.currentVessel).getVesselCarriers().then(data => {
        this.getVesselCarrier(data)
      })
    }
  }

  /**
   * 获取船舶呼号code
   */
  getVesselCarrier(vesselCarriers) {
    for (const carrier of vesselCarriers) {
      if (carrier.carrierId === this.job.carrierId) {
        this.job.vesselCode = carrier.ediCode
        break
      }
    }
  }

  async getVoyageByVessel() {
    if (this.currentVessel && this.currentVessel.vesselId) {
      this._voyages = await Voyage.getVoyage(this.currentVessel.vesselId)
    } else {
      this._voyages = []
    }
  }

  voyageFocusInHandler() {
    let value = 'V.'
    if (this.job.voyageFlight) {
      value = this.job.voyageFlight
      this.job.voyageFlight = ''
    }
    this.view.$nextTick(() => {
      this.job.voyageFlight = value
      const elSelect = this.view.$refs.voyageFlight
      const innerInput = elSelect.$children[0].$refs.input
      innerInput.value = this.job.voyageFlight
    })
  }

  async voyageFocusOutHandler() {
    const job = this.job
    if (this.editVoyageMode === 1) {
      const elSelect = this.view.$refs.voyageFlight
      const innerInput = elSelect.$children[0].$refs.input
      job.voyageFlight = innerInput.value.toUpperCase()
    }
    if (job.bookingTerm === 'SB' && job.destinationPortCode && job.destinationPortCode.length && job.carrierId) {
      if (job.vessel && job.voyageFlight.length > 2) {
        const ediCode = await Vessel.getEDICode(job.vessel, job.voyageFlight, job.destinationPortCode, job.carrierId)
        if (ediCode) {
          job.vesselCode = ediCode
        }
      }
    }
  }

  /**
   * HBL付款方式
   */
  paymentSelectHblChange(data) {
    this.paymentTermHBL_Change(data.value)
  }

  /**
   * HBL付款方式
   */
  paymentTermHBL_Change(value) {
    this.job.paymentTermHBL = value
    // if (value === 'PP') {
    //   this.form.paymentPlaceHBL = this.form.loadingPort
    // } else {
    //   this.form.paymentPlaceHBL = this.form.destinationPort
    // }
  }

  /**
   * 包装
   */
  async packing_Change(data) {
    this.form.packing = data.value
    this.refreshQuantitySum()
    // 包装 不受BillOfLadingSynMode 控制，在其他地方已同步job
    // this.job.packing = this.form.packing
    // await SeaImCargoDoc.changeSynData(new SeaImportJob(this.job), false, this.cargoDoc)
  }

  /**
   * 件数
   */
  async quantity_Change() {
    this.refreshQuantitySum()
    await SeaImCargoDoc.changeSynDataQWC(new SeaImportJob(this.job), false, this.form)
  }

  async txtChargeWeightHandler() {
    await SeaImCargoDoc.changeSynDataQWC(new SeaImportJob(this.job), false, this.form)
  }

  async txtMarkChangeHandler() {
    if (!this.view.isEdit) return
    await SeaImCargoDoc.changeSynData(new SeaImportJob(this.job), false, this.form)
  }

  async txtCargoEnglishNameChangeHandler() {
    if (!this.view.isEdit) return
    await SeaImCargoDoc.changeSynData(new SeaImportJob(this.job), false, this.form)
  }

  /**
   * 打印状态控制
   */
  printStateChange() {
    this.view.btnPrintDisabled = true
    if (this.view.isEdit) {
      return
    }
    if (!this.form) {
      return
    }
    if (this.job.joinFlagHBL && this.job.jointMasterHBLUuid) {
      return
    }
    // 是否异地放单 ,如果是TRUE，正本打印、电放按钮无法打印
    if (this.form.oversea && this.form.releaseType === 1) {
      return
    }
    if (this.form.releaseType === 1) {
      if (this.view.$checkPermission(['button_SiPrintDoc'])) {
        if (this.form.state === 1) {
          this.view.btnPrintDisabled = false
        }
      }
    } else if (this.form.releaseType === BillReleaseType.SURRENDERED.code) {
      // 有权限才行
      if (this.view.$checkPermission(['button_HBL_SiSurrender'])) {
        this.view.btnPrintDisabled = false
      }
    } else {
      this.view.btnPrintDisabled = false
    }
    if (this.form.issuerBL === 'TH') {
      this.view.btnPrintDisabled = true
    }
    if (this.job.shutOut && !this.view.btnPrintDisabled) {
      this.view.btnPrintDisabled = true
    }
  }

  insideQuantity_Change(value) {
    this.job.insideQuantity = value
  }

  async txtWeightChargeHandler() {
    await SeaImCargoDoc.changeSynDataQWC(new SeaImportJob(this.job), false, this.form)
  }

  async txtCubageChargeHandler() {
    await SeaImCargoDoc.changeSynDataQWC(new SeaImportJob(this.job), false, this.form)
  }

  /**
   * 件数大小写合计
   */
  refreshQuantitySum() {
    let packingName = ''
    if (this.form.packing) {
      const packing = getObjectByCache(basicCacheKeys.basic_data_Packing, 'code', this.form.packing)
      packingName = packing ? packing.name : ''
    }
    this.form.quantitySum = StrUtils.jsdx(this.form.quantity, packingName)
  }

  /**
   * 分单签发日期修改
   */
  txtsignDateHBLChangeHandler(event) {
    // view.cargoDoc.signDateBL = view.txtsignDateHBL.selectedDate
  }

  /**
   * 装箱信息显示
   */
  chargeContainer(event = null) {
    if (this.job.containerLoadType === 'BB') {
      this.form.container = SeaExportUtils.getContainerDesc(this.job, this.form.printParam3)
    }
  }

  /**
   * 是否有解锁权限
   */
  checkUnlockBtnState() {
    this._view.unlockDisabled = !(this.form && this.form.state === 2 && this.$checkPermission(['M/HBL_unlock']))
  }

  /**
   * bug 996:如果HBL是已送出状态，则不允许更改“提单方式”
   */
  async checkReleaseTypeState() {
    if (!this.view.isEdit) return
    let bool = true
    await new SeaImportJob(this.job).getFile()
    for (const f of this.job.file) {
      if (f.fileType === FileType.HBL_TYPE.code.toString() && f.state === 1) {
        bool = false
        break
      }
    }
    this.view.btnPrintDisabled = !bool
  }

  showCarrierAgentScac() {
    const company = this.context.companyList.find(p => p.cmpIdx === this.job.carrierId)
    this.view.txtCarrierScAc = company ? company.scac : ''
    const company1 = this.context.companyList.find(p => p.cmpIdx === this.job.destinationAgent)
    this.view.txtBookingAgentScAc = company1 ? company1.scac : ''
  }

  docCfmStateChanged() {
    const isZh = this.view.$i18n.locale === 'zh'
    const releaseState = ReleaseState.getReleaseStateByCode(this.form.releaseState)
    if (releaseState) {
      this.view.lblReleaseState = isZh ? releaseState.chineseName : releaseState.englishName
    }
  }

  async changeAfrAddress() {
    // 非选中状态，清除新增的afrAddress，避免保存无用数据(新增状态先选中后又取消的场景)
    if (!this.form.chkConsolidationClosed) {
      if (this.form.afrAddress && this.form.afrAddress.length > 0) {
        if (this.form.afrAddress[0].uuid) {
          this.form.afrAddress[0].consolidationClosed = this.form.chkConsolidationClosed ? 1 : 0
        } else {
          this.form.afrAddress = []
        }
      }
      return
    }

    if (this.form.chkConsolidationClosed) {
      let afrAddress = null
      if (!this.form.afrAddress || this.form.afrAddress.length === 0) {
        this.form.afrAddress = []
        afrAddress = new AfrAddress().fillDefaultValue().getData()
        afrAddress.state = 0
        afrAddress.docType = CargoDocConsts.AFR
        afrAddress.cargoDocUuid = this.form.uuid
        this.form.afrAddress.push(afrAddress)
      } else {
        afrAddress = this.form.afrAddress[0]
      }
      if (afrAddress) {
        afrAddress.consolidationClosed = this.form.chkConsolidationClosed ? 1 : 0
      }
    }
  }

  /**
   * 锁定业务页签
   */
  lockBookingTab() {
    this.job.printHblZbLock = (this.form.releaseType === 1 && this.config.get('HBLPrintLockTab') === 1)
  }

  /**
   * 开始创建File
   */
  async startCreateFile() {
    if (!this.form) {
      return
    }
    const count = await File.queryFilesCount({ 'jobNo': this.job.jobNo, 'fileNo': this.form.hblNbr2 })
    await this.fileCountResultHandler(count)
  }

  async fileCountResultHandler(count = 0) {
    if (count <= 0) {
      await this.createFileOnPrintZB()
    }
  }

  /**
   * 生成单证流转在打印正本的时候
   */
  async createFileOnPrintZB() {
    const file = await File.createFileByJob(this.job)
    file.fileType = FileType.HBL_TYPE.code + ''
    file.fileNo = this.form.hblNbr2
    await File.saveFile(file)
  }

  /**
   * 取MBL信息
   */
  async getMBLInfo(type) {
    await new SeaImportJob(this.job).getSeaCargoDoc()
    let mbl = null
    for (const doc of this.job.seaCargoDoc) {
      if (doc.docType === CargoDocConsts.MBL) {
        mbl = doc
        break
      }
    }
    if (mbl) {
      if (type === 'mark') {
        this.form.mark = mbl.mark
      } else if (type === 'EName') {
        this.form.cargoEnglishName = mbl.cargoEnglishName
      }
    }
  }

  /**
   * 编辑船名航次模式
   */
  editInputVesselModel() {
    this._allowEditingVessel = false
    switch (this.editVesselVoyageMode) {
      case 1:
        this._allowEditingVessel = true
        break
      case 2:
        if (this.job.bookingTerm !== BookingTerm.OS_BOOKING_TYPE.code) {
          this._allowEditingVessel = true
        }
        break
      case 3:
        this._allowEditingVessel = false
        break
      default:
        break
    }
  }

  /**
   * 是否可编辑件毛体
   */
  controlQwcRoleEdit() {
    this.isCanEditQwc = this.view.isEdit && !this.job.jointMasterHBLUuid
  }

  /**
   * 编辑控制
   */
  async editingChanged() {
    if (this.view.isEdit && this.job.joinFlagHBL && this.job.jointMasterHBL && !this.isEditSingleCargoDoc) {
      this.jionFlag = true
    }
    await this.loadJointSlaves2Handler()
    this.lclslaveEnabledChanged()
    this.controlQwcRoleEdit()
  }

  /**
   * 拼箱小票，不允许编辑：目的港代理、船名、航次、订舱单位、船公司、主单运费条款、卸货港
   */
  lclslaveEnabledChanged() {
    this._lclslaveEnabled = this.view.isEdit && !this.job.lclMasterUuid
  }

  /**
   * 客户自出单
   */
  isCustomerSelfRelease(value) {
    if (value) {
      this.form.customerSelfRelease = 1
    } else if (this.form.customerSelfRelease === 1) {
      this.form.customerSelfRelease = 0
    }
  }

  /**
   * 公司自出单
   */
  isCompanySelfRelease(value) {
    if (value) {
      this.form.customerSelfRelease = 2
    } else if (this.form.customerSelfRelease === 2) {
      this.form.customerSelfRelease = 0
    }
  }
}
